import { useQuery } from '@tanstack/react-query';

import { queries } from '../../common/api/queryKeys/queries';
import { useRole } from '../../common/hooks/useRole';
import { SortingKey } from '../components/SortingKey';

export const useDemandInformation = (sortingKey: SortingKey, groupId?: string) => {
    const role = useRole();

    return useQuery({
        ...queries.demandInformation.byParams(sortingKey, groupId),
        enabled: !role.isSuperAdmin() || groupId !== undefined,
    });
};
